<div class="home-container">
  <div class="guest-container">
    <div class="guest-header">
      <div class="logo-wrap">
        <img src="assets/logo-jjames.webp" alt="JJames Logo" class="app-logo">
      </div>
      @if (spaceName()) {
        <h1 class="guest-title">{{ spaceName() }}</h1>
      }
    </div>

    <div class="public-search-card">
      @if (isLoading()) {
        <mat-spinner diameter="32"></mat-spinner>
      } @else if (notFound()) {
        <p>{{ 'GUEST_PAY.SITE_NOT_FOUND' | translate }}</p>
      } @else {
        <app-license-plate [parkingSpaceId]="parkingSpaceId()"></app-license-plate>
      }
    </div>
  </div>
</div>
